<template>
  <div>
    <app-header></app-header>
    <div class="app-main">
      <app-silder></app-silder>
      <router-view></router-view>
    </div>
    <div class="app-bg"></div>     
  </div>    
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
export default {
  components: {
    AppHeader,
    AppSilder
  }
}
</script>



// WEBPACK FOOTER //
// src/views/classroom/index.vue